import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import YupPassword from "yup-password";
YupPassword(Yup);

export default function AddCredentialsForm(props) {
  const { signInData, setSignInData, handleNext, handleBack } = props;

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      // .min(
      //   6,
      //   "password must contain 6 or more characters with at least one of each: uppercase, lowercase, number and special"
      // )
      // .minLowercase(1, "password must contain at least 1 lower case letter")
      // .minUppercase(1, "password must contain at least 1 upper case letter")
      // .minNumbers(1, "password must contain at least 1 number")
      // .minSymbols(1, "password must contain at least 1 special character")
      .required("Please add password"),
    confirmPws: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  const handleChangeClassType = (event) => {
    setSignInData((prev) => ({ ...prev, classType: event.target.value }));
  };

  const formik = useFormik({
    initialValues: {
      confirmPws: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        setSignInData((prev) => ({ ...prev, ...values }));
        handleNext();
        resetForm();
      } catch (error) {
        setSubmitting(false);
      }
    },
  });

  return (
    <React.Fragment>
      <FormikProvider value={formik}>
        <Typography variant="h6" gutterBottom>
          Select Class
        </Typography>
        <FormControl sx={{ width: "80%" }}>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={signInData.classType}
            onChange={handleChangeClassType}
          >
            <FormControlLabel
              value="chemistry"
              control={<Radio />}
              label="Chemistry"
            />
            <FormControlLabel
              value="physics"
              control={<Radio />}
              label="Physics"
            />
            <FormControlLabel
              value="both"
              control={<Radio />}
              label="Chemistry and Physics"
            />
          </RadioGroup>
        </FormControl>
        <Form onSubmit={formik.handleSubmit}>
          <React.Fragment>
            <Typography variant="h6" gutterBottom sx={{ marginTop: "20px" }}>
              Add Password
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  id="password"
                  label="Password"
                  placeholder="Pass123@"
                  fullWidth
                  type="password"
                  variant="standard"
                  name="password"
                  autoCapitalize="off"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                <ErrorMessage name="password">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="confirmPws"
                  label="Confirm Password"
                  fullWidth
                  variant="standard"
                  type="password"
                  name="confirmPws"
                  autoComplete="off"
                  onChange={formik.handleChange}
                  value={formik.values.confirmPws}
                />
                <ErrorMessage name="confirmPws">
                  {(msg) => (
                    <div
                      style={{
                        color: "red",
                        textAlign: "left",
                        fontSize: "12px",
                      }}
                    >
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                Back
              </Button>
              <Button variant="contained" sx={{ mt: 3, ml: 1 }} type="submit">
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Form>
      </FormikProvider>
    </React.Fragment>
  );
}
